import { Node, mergeAttributes } from "@tiptap/core";

/**
 * Hint Node ("Hinweis")
 *
 * Callout-Block im Stil der Backend-Hinweise (z. B. Portalzugang auf der
 * Firmen-Detailseite): Accent-Hintergrund, Info-Icon (per CSS ::before),
 * kleiner gedämpfter Text. Inhalt ist Inline-Content, Marks sind erlaubt.
 */

export interface HintNodeOptions {
  HTMLAttributes: Record<string, unknown>;
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    hint: {
      /** Wandelt den aktuellen Block in einen Hinweis um. */
      setHint: () => ReturnType;
    };
  }
}

export const HintNode = Node.create<HintNodeOptions>({
  name: "hint",
  group: "block",
  content: "inline*",
  defining: true,

  addOptions() {
    return {
      HTMLAttributes: {
        class: "tiptap-hint",
      },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="hint"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(
        { "data-type": "hint" },
        this.options.HTMLAttributes,
        HTMLAttributes
      ),
      0,
    ];
  },

  addCommands() {
    return {
      setHint:
        () =>
        ({ commands }) =>
          commands.setNode(this.name),
    };
  },
});
